import React from 'react';

import { Box } from '@mui/material';

import { AuthPaperBox, Login } from 'src/components/auth';
import type { SxProp } from 'src/types/mui';

export const LoginPage: React.FC = () => {
  return (
    <AuthPaperBox>
      <Box sx={withoutLogoContainerStyles}>
        <Login />
      </Box>
    </AuthPaperBox>
  );
};

const withoutLogoContainerStyles: SxProp = {
  display: 'grid',
  gridGap: '30px',
};
